import React from 'react';
import PropTypes from 'prop-types';

export const PluginPlaylistIcon = ({ small = false, ...rest }) => {
  if (small) {
    return (
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M1 1H23C23.2761 1 23.5 1.22386 23.5 1.5V23.5C23.5 23.7761 23.2761 24 23 24H1C0.723858 24 0.5 23.7761 0.5 23.5V1.5C0.5 1.22386 0.723858 1 1 1Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
      </svg>
    );
  }

  return (
    <svg
      width="101"
      height="105"
      viewBox="0 0 101 105"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect x="1" y="0.5" width="99" height="103.511" rx="3.5" fill="#F4F4F4" stroke="#AEAEAE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6533 81.2221C26.9787 80.8967 26.9787 80.369 26.6533 80.0436C26.3278 79.7181 25.8002 79.7181 25.4748 80.0436L19.6414 85.8769C19.316 86.2023 19.316 86.73 19.6414 87.0554L25.4748 92.8888C25.8002 93.2142 26.3278 93.2142 26.6533 92.8888C26.9787 92.5633 26.9787 92.0357 26.6533 91.7102L22.2425 87.2995H31.8973C32.3576 87.2995 32.7307 86.9264 32.7307 86.4662C32.7307 86.0059 32.3576 85.6328 31.8973 85.6328H22.2425L26.6533 81.2221Z"
        fill="#525252"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.2773 80.0436C75.9518 79.7181 75.4242 79.7181 75.0988 80.0436C74.7733 80.369 74.7733 80.8967 75.0988 81.2221L79.5095 85.6328H69.8547C69.3945 85.6328 69.0214 86.0059 69.0214 86.4662C69.0214 86.9264 69.3945 87.2995 69.8547 87.2995H79.5095L75.0988 91.7102C74.7733 92.0357 74.7733 92.5633 75.0988 92.8888C75.4242 93.2142 75.9518 93.2142 76.2773 92.8888L82.1106 87.0554C82.4361 86.73 82.4361 86.2023 82.1106 85.8769L76.2773 80.0436Z"
        fill="#525252"
      />
    </svg>
  );
};

PluginPlaylistIcon.propTypes = {
  small: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/PluginPlaylistIcon.jsx